import PropTypes from 'prop-types';
import React from "react";

export default function InsiderIcon({title, colour}) {

  const filename = colour === "white" ? "insiders-white.png" : "insiders-blue.png";
  const src = `/img/icons/${filename}`;

  return (
    <img className="insider-icon icon" src={src} title={title} />
  );
}

InsiderIcon.propTypes = {
  title: PropTypes.string.isRequired,
  colour: PropTypes.string
};



// WEBPACK FOOTER //
// ./modules/Common/components/png/InsiderIcon.js